import { Link } from "react-router-dom";
import { ArrowRight, Monitor, Smartphone, Globe } from "lucide-react";
import { Button } from "@/components/ui/button";
import { motion } from "framer-motion";
import webseitenPreview from "@/assets/guenstige-webseite-aachen-beispiel.png";
import SectionHeader from "@/components/SectionHeader";
const WebseitenShowcase = () => {
  return <section className="py-24 md:py-32 bg-gradient-to-b from-background via-background to-muted/20 relative overflow-hidden">
      {/* Subtle background gradient */}
      <div className="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-accent-purple/5 pointer-events-none" />
      
      <div className="container mx-auto px-4 md:px-8 max-w-7xl relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
          {/* Left: Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} viewport={{
          once: true
        }} className="order-2 lg:order-1">
            <SectionHeader badge="Webseiten Agentur" title="Websites, die verkaufen" highlightedWord="verkaufen" centered={false} className="mb-8" />

            <p className="text-lg md:text-xl text-muted-foreground mb-8 max-w-lg leading-relaxed font-sans">
              Wir designen & entwickeln Webseiten, die Ihre Marke perfekt präsentieren und Besucher in Kunden verwandeln.
            </p>

            {/* Features */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10">
              {[{
              icon: Monitor,
              text: "Modern & Responsiv"
            }, {
              icon: Smartphone,
              text: "Mobile First"
            }, {
              icon: Globe,
              text: "SEO Optimiert"
            }].map((feature, index) => <div key={index} className="flex items-center gap-3 text-foreground/80">
                  <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
                    <feature.icon className="w-5 h-5 text-accent" />
                  </div>
                  <span className="text-sm font-medium font-sans">{feature.text}</span>
                </div>)}
            </div>

            {/* CTA */}
            <a href="https://web.aivinity.de" target="_blank" rel="noopener noreferrer">
              <Button className="group bg-accent hover:bg-accent/90 text-primary font-bold text-base px-8 py-4 h-auto rounded-lg shadow-[0_0_20px_rgba(134,239,172,0.3)] hover:shadow-[0_0_30px_rgba(134,239,172,0.5)] transition-all duration-300">
                <span className="font-sans font-bold">Webseiten entdecken</span>
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
          </motion.div>

          {/* Right: iPad Mockup with Website Preview */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} viewport={{
          once: true
        }} className="order-1 lg:order-2 relative">
            {/* iPad-like frame */}
            <div className="relative mx-auto max-w-lg lg:max-w-none">
              {/* Outer iPad frame */}
              <div className="relative bg-gradient-to-br from-zinc-800 via-zinc-900 to-black p-3 md:p-4 rounded-[2rem] md:rounded-[3rem] shadow-2xl shadow-black/50">
                {/* Camera notch */}
                <div className="absolute top-6 left-1/2 -translate-x-1/2 w-2 h-2 rounded-full bg-zinc-700" />
                
                {/* Screen */}
                <div className="relative rounded-[1.5rem] md:rounded-[2rem] overflow-hidden bg-white aspect-[4/3]">
                  <img alt="Günstige Webseite Aachen - Webseitenagentur Beispiel" className="w-full h-full object-cover object-top" src="/lovable-uploads/a560ab2e-2b12-4cd9-8eb2-f4298c112898.webp" loading="lazy" decoding="async" />
                  
                  {/* Screen reflection overlay */}
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 via-transparent to-transparent pointer-events-none" />
                </div>
              </div>

              {/* Decorative elements */}
              <div className="absolute -bottom-4 -right-4 w-32 h-32 bg-accent/20 rounded-full blur-3xl" />
              <div className="absolute -top-4 -left-4 w-24 h-24 bg-accent-purple/20 rounded-full blur-3xl" />
              
              {/* Floating badge */}
              <motion.div initial={{
              opacity: 0,
              scale: 0.8
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} transition={{
              duration: 0.4,
              delay: 0.6
            }} viewport={{
              once: true
            }} className="absolute -bottom-6 -left-6 md:-bottom-8 md:-left-8 bg-card/95 backdrop-blur-xl border border-accent/30 rounded-xl p-4 shadow-xl">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-lg bg-accent/20 flex items-center justify-center">
                    <span className="text-accent text-xl font-bold font-sans">✓</span>
                  </div>
                  <div>
                    <p className="text-sm font-semibold text-foreground font-sans">Ab 1.490€</p>
                    <p className="text-xs text-muted-foreground font-sans">Professionelle Webseite</p>
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default WebseitenShowcase;